import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { api } from '../../../utils/api.ts';
import { DisplayId } from '../../list-views/components/display-id.tsx';
import { SearchCombobox } from '../../shared/components/search-combobox/search-combobox.tsx';

type Props = {
    customerId: string | null;
    value?: string;
    onChange: (value?: string) => void;
    disabled: boolean;
    isLoading?: boolean;
};

export const SearchStorageLocationCombobox: React.FC<Props> = ({
    customerId,
    value,
    onChange,
    disabled,
    isLoading: propsIsLoading,
}) => {
    const { t } = useLocale();

    const {
        data: storageLocationsFromServer,
        isLoading: isLoadingStorage,
        fetchStatus,
    } = api.platoUser.writeBackOptionsHeader.getCustomerStorageLocations.useQuery(
        {
            erpCustomerId: customerId ?? null,
        },
        {
            enabled: !!customerId,
        },
    );

    const isLoading = isLoadingStorage && fetchStatus === 'fetching';
    const storageLocations = storageLocationsFromServer ?? [];

    return (
        <SearchCombobox
            className="w-full"
            isLoading={isLoading}
            groupedItems={[
                {
                    id: 'storageLocations',
                    items: storageLocations,
                },
            ]}
            notFoundPlaceholder={''}
            inputPlaceholder={t('placeholder__select_storage')}
            keySelector={(item) => item.id}
            valueSelector={(item) => item.id}
            keywordsSelector={(item) => [item.id, item.name]}
            renderItem={(item) => (
                <>
                    <DisplayId id={item.id} suffix=": " />
                    {item.name}
                </>
            )}
            onValueChange={onChange}
            selectedValue={value || ''}
            disabled={!customerId || disabled}
        />
    );
};
